<!-- 
 * @description: 底部信息模块
 * @fileName: template.vue 
 * @author: 赖雪婷 
 * @date: 2022-04-18 17:11:40
!-->
<template>
  <div
    :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mfooter' : 'footer'"
    v-if="isShow"
  >
    <div class="foot_cont">
      <i class="icon" v-if="this.$Base.checkSysteam() == 'PC'">
        <img src="../../assets/info2.png" alt="" />
      </i>
      <div>
        <div class="foot_btn">
          <a
            href="https://www.etolies.com/protocol/rules.html"
            title="會員條款"
            target="_blank"
            >會員條款</a
          >
          <span>|</span>
          <a
            href="https://www.etolies.com/protocol/privacy.html"
            title="隱私條款"
            target="_blank"
            >隱私條款</a
          >
        </div>
        <p
          class="p"
          id="copy_text"
          v-if="
            urlParams.appId === '105409' &&
            urlParams.pid === '397' &&
            urlParams.md_id === '200000'
          "
        >
          客服信箱：{{ this.mswzNetbarNumber }}
        </p>
        <p class="p" id="copy_text" v-else>客服信箱：{{ this.NetbarNumber }}</p>
        <p class="bq">Copyright © 2020 LT Technology Ltd.All Rights Reserved</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getUrlParams } from "../../utils/getUrlParams";
export default {
  name: "RastarFooter",
  data() {
    return {
      NetbarNumber: "maplestoryR.cs@gmail.com",
      mswzNetbarNumber: "sgsxf.rastargame@gmail.com",
      fullHeight: document.documentElement.clientHeight, //视口高
      isShow: true,
      urlParams: getUrlParams(),
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        console.log("window.fullHeight", window.fullHeight);
        that.fullHeight = window.fullHeight;
        console.log(that.fullHeight);
      })();
    };
  },
  watch: {
    fullHeight(val) {
      if (!this.timer) {
        this.fullHeight = val;
        console.log("fullHeight", this.fullHeight);
        let system = this.$Base.checkSysteam();
        if (this.fullHeight < 400 && system == "MOBILE") {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  methods: {
    // 获取可使窗口显示隐藏
  },
  created() {
    console.log("foot初始化", this.fullHeight);
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
